import { Route, Routes, useLocation } from "react-router"
import { IPETest, TEST_CURRENT_MODE } from "../../data/interfaces"
import Finish from "./Finish"
import Question from "./Question"
import Results from "./Results"
import Start from "./Start"
import Test from "./Test"
import { CSSProperties } from "react"

export interface ITestProps {
    item: IPETest
    mode?: TEST_CURRENT_MODE
    titleStyle?: CSSProperties
}
const SingleTest = (props: ITestProps) : JSX.Element => { 
    return <>
        <Routes data-testid="single-test">
            <Route element={<Test {...props} />}>
                <Route index element={ <Start {...props} /> } />
                <Route path="finish" element={ <Finish {...props} /> } />
                <Route path="results" element={ <Results {...props} /> } />
                <Route path="question/:question_id" element={ <Question {...props} /> } />
            </Route>
        </Routes> 
    </> 
} 

export default SingleTest